export default "__VITE_ASSET__DzHjjXna__"